import { render, staticRenderFns } from "./discus-1.vue?vue&type=template&id=0ed62afe&scoped=true&"
import script from "./discus-1.vue?vue&type=script&lang=js&"
export * from "./discus-1.vue?vue&type=script&lang=js&"
import style0 from "./discus-1.vue?vue&type=style&index=0&id=0ed62afe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed62afe",
  null
  
)

export default component.exports